<form
  #changePasswordForm="ngForm"
  *ngIf="!isGoogleUser"
  role="form"
  (submit)="saveChanges()"
  [formGroup]="changePasswordFormGroup"
>
  <p>
    <mat-form-field class="w-full" appearance="fill">
      <mat-label i18n>Current Password</mat-label>
      <input
        matInput
        id="oldPassword"
        type="password"
        name="oldPassword"
        formControlName="oldPassword"
        required
      />
      <mat-error *ngIf="changePasswordFormGroup.controls['oldPassword'].hasError('required')" i18n
        >Current Password required</mat-error
      >
      <mat-error
        *ngIf="changePasswordFormGroup.controls['oldPassword'].hasError('incorrectPassword')"
        i18n
        >Current Password is incorrect</mat-error
      >
    </mat-form-field>
  </p>
  <div formGroupName="newPasswordFormGroup">
    <new-password-and-confirm [formGroup]="newPasswordFormGroup"></new-password-and-confirm>
  </div>
  <p>
    <button
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="!changePasswordFormGroup.valid || isSaving"
      class="button--progress"
    >
      <ng-container i18n>Change Password</ng-container>
      <mat-progress-bar mode="indeterminate" *ngIf="isSaving"></mat-progress-bar>
    </button>
  </p>
</form>
<ng-container *ngIf="isGoogleUser">
  <p class="flex flex-row flex-wrap items-center gap-2 pt-2">
    <span class="flex items-center gap-2">
      <img
        class="google-icon align-middle"
        src="assets/img/icons/google-logo.svg"
        i18n-alt
        alt="Google logo"
      />
      <span i18n>This account was created using Google and doesn't use a WISE password.</span>
    </span>
    <button
      id="unlinkGoogleAccount"
      class="unlink"
      type="button"
      mat-raised-button
      (click)="unlinkGoogleAccount()"
    >
      <span class="warn" i18n>Unlink Google Account</span>
    </button>
  </p>
</ng-container>
